export const OPTIONS_STEP = 5;
export const DEFAULT_GROUP_LABEL = 'default group';
export const ADDED_GROUP_LABEL = 'added group';
